module.exports = __webpack_public_path__ + "img/swiper33.6cc0a7e4.jpg";